//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import BankCardConciliationListView from '@/views/Accounting/AccBankCardConciliation/AccBankCardConciliationList'
import BankCardConciliationSuggestView from '@/views/Accounting/AccBankCardConciliation/AccBankCardConciliationSuggest'

//
export default {
    path: 'bank_conciliation',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'bank-card-conciliations-list',
            component: BankCardConciliationListView,
        },
        {
            path: 'suggest',
            name: 'bank-card-conciliations-suggest',
            component: BankCardConciliationSuggestView,
        },
    ],
    meta: {
        title: 'Conciliaciones bancarias',
    },
}
